import { createSelector } from 'reselect'

import { PLAN_TYPES } from 'containers/App/constants'
import {
  selectActualLicenses,
  selectLastProductRelease,
  selectLastSeenProductRelease,
} from 'containers/App/selectors'

import { Help, IronscalesConnect, Message, ProductUpdates } from 'components/lib/DesignSystem/Icons'

const selectPlanIsStarter = (state) => selectActualLicenses(state).plan === PLAN_TYPES.STARTER

export const selectHelpMenuItems = createSelector(
  selectPlanIsStarter,
  selectLastProductRelease,
  selectLastSeenProductRelease,
  (planIsStarter, lastProductRelease, lastSeenProductRelease) => {
    const items = []
    if (!planIsStarter) {
      items.push({
        name: 'Help Center',
        Icon: Help,
        url: 'https://support.ironscales.com/hc/en-us',
      })
    }
    items.push({
      name: 'IRONSCALES Discord',
      Icon: IronscalesConnect,
      url: 'https://secure.ironscales.com/discord-community-access-request',
    })
    if (lastProductRelease) {
      items.push({
        name: 'Latest Release Note',
        Icon: ProductUpdates,
        url: 'https://support.ironscales.com/hc/en-us/articles/24649708179228-What-s-new-in-this-release',
        showRedIndication:
          lastProductRelease?.created &&
          new Date(lastSeenProductRelease) < new Date(lastProductRelease.created),
      })
    }
    items.push({
      name: `${planIsStarter ? 'Contact Support' : 'Leave us a message'}`,
      Icon: Message,
      url: 'https://support.ironscales.com/hc/en-us/requests/new',
    })
    return items
  }
)
